module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.directLoginLoading),
      expression: "directLoginLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "id": "app"
    }
  }, [(_vm.authRequested) ? _c('div', {
    attrs: {
      "id": "router-mount"
    }
  }, [_c('router-view')], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Alert",
      "visible": _vm.warningDialogVisible,
      "width": "40%",
      "close-on-click-modal": false,
      "show-close": false,
      "close-on-press-escape": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.warningDialogVisible = $event
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s("<p>This is a warning message. To continue the test, please call Impact Analytics team.</p><p><span style='color: #ff0000;'><strong>Warning:</strong>&nbsp;Your activity is being tracked.</span></p>")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        _vm.warningDialogVisible = false
      }
    }
  }, [_vm._v("Okay")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b3c5b1b6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 499
// module chunks = 6